import request from '@/utils/request'
import api from '../api'

export class Easypay {
  basicenterprise(data) {
    return request({
      url: api.easypay.basicenterprise,
      method: 'post',
      data
    })
  }
  verifyBank(data) {
    return request({
      url: api.easypay.verifyBank,
      method: 'post',
      data
    })
  }
  crabinSearch(params) {
    return request({
      url: api.easypay.crabinSearch,
      method: 'get',
      params
    })
  }
  verifyMsgCode(data) {
    return request({
      url: api.easypay.verifyMsgCode,
      method: 'post',
      data
    })
  }
}